module.exports = __webpack_public_path__ + "static/media/Avenir-Roman.28d50250.woff";